/* eslint-disable react-hooks/set-state-in-effect */
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useState, useEffect } from "react";

import "./dashboard.css";
// import Navbar from "./Navbar";
import { useSnapshot } from "valtio";
import { userStore } from "../../hooks/store";
import { WebsiteStore, editorState } from "../../utils/editor";
import { Flex, useMediaQuery } from "@chakra-ui/react";
import CustomDrawer from "../../components/CustomDrawer";
import LoadingScreen from "../../pages/Dashboard/LoadingScreen";
import WelcomeScreen from "../../pages/Dashboard/welcome-screen";
import { ClientStorage, ClientStorageItem } from "../../utils/clientstorage";
import CheckInDrawer from "../../pages/Website/layout/components/modals/CheckInDrawer";
import MobileNav from "../../components/dashboard/mobile-nav";
// import TopNavBar from "../../pages/Website/layout/components/TopNavBar";
import TopNav from "./TopNavBar";
import { useEventPlannerPath } from "../../hooks/useEventPlannerPath";

const DashboardLayout = () => {
  const [showLoading, setShowLoading] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [isSmallerThan900] = useMediaQuery("(max-width: 900px)");
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const ctx = searchParams.get("ctx");
  const navigate = useNavigate();
  const location = useLocation();
  const { data: userData } = useSnapshot(userStore);
  const { isCheckInDrawerOpen } = useSnapshot(WebsiteStore);
  const { weddingID } = useSnapshot(editorState);
  const { basePath: basePathWithWeddingId, userWeddingRole } =
    useEventPlannerPath();

  const isCateringFlow = location.pathname.includes("/catering");

  useEffect(() => {
    const getWeddingStorageKey = (key: ClientStorageItem): string => {
      return `${weddingID}_${key}`;
    };

    const hasSeenDashboard = ClientStorage.fetch(
      getWeddingStorageKey(
        ClientStorageItem.HasSeenDashboard,
      ) as ClientStorageItem,
    );
    const hasSeenWelcome = ClientStorage.fetch(
      getWeddingStorageKey(
        ClientStorageItem.HasSeenWelcome,
      ) as ClientStorageItem,
    );

    if (!hasSeenDashboard) {
      setShowLoading(true);
    } else if (hasSeenWelcome === "false") {
      setShowWelcome(true);

      const welcomeTimer = setTimeout(() => {
        setShowWelcome(false);
        ClientStorage.store(
          getWeddingStorageKey(
            ClientStorageItem.HasSeenWelcome,
          ) as ClientStorageItem,
          "true",
        );
      }, 3000);

      return () => clearTimeout(welcomeTimer);
    }
  }, [weddingID]);

  const handleLoadingComplete = () => {
    setShowLoading(false);
    const getWeddingStorageKey = (key: ClientStorageItem): string => {
      return `${weddingID}_${key}`;
    };
    
    ClientStorage.store(
      getWeddingStorageKey(
        ClientStorageItem.HasSeenDashboard,
      ) as ClientStorageItem,
      "true",
    );

    const hasSeenWelcome = ClientStorage.fetch(
      getWeddingStorageKey(
        ClientStorageItem.HasSeenWelcome,
      ) as ClientStorageItem,
    );

    if (hasSeenWelcome === "false") {
      setShowWelcome(true);
      const welcomeTimer = setTimeout(() => {
        setShowWelcome(false);
        ClientStorage.store(
          getWeddingStorageKey(
            ClientStorageItem.HasSeenWelcome,
          ) as ClientStorageItem,
          "true",
        );
      }, 3000);

      return () => clearTimeout(welcomeTimer);
    }
  };

  if (showLoading) {
    return <LoadingScreen userWeddingRole={userWeddingRole} onCountdownEnd={handleLoadingComplete} />;
  }

  if (showWelcome) {
    return (
      <WelcomeScreen
        userWeddingRole={userWeddingRole}
        name={
          userData?.firstname ||
          userData?.lastname ||
          userData?.businessName ||
          ""
        }
      />
    );
  }

  return (
    <Flex
      className={"no-scrollbar"}
      w={"full"}
      h={"100dvh"}
      bgColor={isCateringFlow ? "#ECECEC" : "#F9F9F9"}
      justifyContent={"center"}
      pos={"relative"}
    >
      <Flex
        flexDirection={"column"}
        w={"full"}
        maxW={"full"}
        // {...(isSmallerThan900 && {rowGap:"0.25rem"})}
      >
        {!isSmallerThan900 && (
          <Flex
            w={"full"}
            alignItems={"center"}
            justifyContent={"center"}
            h={{ base: "3.286875rem", md: "3.974375rem", lg: "4.35rem" }}
          >
            {/*<Navbar />*/}
            <TopNav />
          </Flex>
        )}
        <Flex
          w={"full"}
          h={{
            base: "calc(100dvh - 3.286875rem)", // Subtract mobile nav height (5rem = 80px)
            md: "calc(100dvh - 3.974375rem)",
            lg: "calc(100dvh - 4.35rem)",
          }}
          overflow={"scroll"}
          className={"no-scrollbar"}
          // mt={{
          //   md:  !isSmallerThan900 ? "4.5rem" : undefined,
          //   lg: "4.5rem",
          // }}
        >
          <Flex
            w={"full"}
            maxW={"1440px"}
            m={"0 auto"}
            {...(pathname.includes("/website/edit")
              ? {
                  boxShadow:
                    "-2px 0 114px rgba(0, 0, 0, 0.025), 2px 0 114px rgba(0, 0, 0, 0.025)",
                }
              : {})}
          >
            <Outlet />
          </Flex>
        </Flex>
      </Flex>
      {(pathname === "/" ||
        pathname === "/weddnpro-subscription" ||
        pathname === "/support" ||
        basePathWithWeddingId) && <MobileNav activeTab="home" />}

      <CustomDrawer
        borderTopRadius={false}
        placement={"right"}
        isOpen={isCheckInDrawerOpen || ctx === "check-in"}
        closeOnOverlayClick={true}
        closeOnEsc={true}
        onClose={() => {
          WebsiteStore.isCheckInDrawerOpen = false;
          navigate(basePathWithWeddingId);
        }}
        h={"full"}
        content={
          <CheckInDrawer
            onClose={() => {
              WebsiteStore.isCheckInDrawerOpen = false;
              navigate(basePathWithWeddingId);
            }}
          />
        }
      />
    </Flex>
  );
};

export default DashboardLayout;
